import { ReactNode } from 'react';

import { DataTableComponents } from './types';

type GetPlaceholderComponentArgs = {
  isLoading?: boolean;
  error?: unknown;
  data?: unknown[];
  components?: DataTableComponents;
};

export const getPlaceholderComponent = ({
  isLoading,
  error,
  data,
  components,
}: GetPlaceholderComponentArgs): ReactNode | undefined => {
  if (isLoading) {
    return undefined;
  }
  if (error && components?.failed) {
    return components?.failed;
  }
  if (!data?.length && components?.noData) {
    return components.noData;
  }
  return undefined;
};
